import { useState } from "react"
import { authRequest } from "src/engine/modules/authRequest"
import { PENDING, COMPLETED, FAILED } from "src/engine/modules/constants"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import { ENTITY_CONST } from "./actionConstants"

export const useEntityActions = ({ name, key, actionMethod, withRedirect }) => {
  const { url, method } = ENTITY_CONST[name][actionMethod]
  const getMessage = ENTITY_CONST[name].messages[actionMethod]
  const [actionStatus, changeStatus] = useState({ PENDING, validate: {} })
  const action = actionData =>
    authRequest({
      url: url(key),
      method,
      data: actionData,
    })
      .then(res => {
        const { data } = res
        showToast({
          type: `success`,
          message: getMessage(data.name),
          hideIn: 5,
        })
        changeStatus({ COMPLETED, validate: {} })
        if (withRedirect) {
          withRedirect.history.push(`${withRedirect.redirectUrl}${data.id}`)
        }
      })
      .catch(error =>
        changeStatus({ FAILED, validate: get(error, `response.data.body`) }),
      )
  return { actionStatus, entityAction: action }
}
